// extracted by mini-css-extract-plugin
export var heading = "topIconList-module--heading--OSw+t";
export var icon = "topIconList-module--icon--zTyqt";
export var iconContainer = "topIconList-module--iconContainer--81Jut";
export var list = "topIconList-module--list--72VIt";
export var listItem = "topIconList-module--listItem--Uxrhy";
export var show = "topIconList-module--show--y2Nk5";
export var text = "topIconList-module--text--vhXSg";